import cdmData from '../data/cyberDefenseMatrix.json'

function TechnologyDetailModal({ technology, onEdit, onClose }) {
  if (!technology) return null

  const assetLabels = (technology.assetClasses || []).map(
    ac => cdmData.assetClasses.find(a => a.id === ac)?.name || ac
  )
  const functionLabels = (technology.operationalFunctions || []).map(
    fn => cdmData.operationalFunctions.find(f => f.id === fn)?.name || fn
  )

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white truncate pr-4">
            {technology.name}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 flex-shrink-0"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-5">
          {/* Vendor & Category row */}
          <div className="grid grid-cols-2 gap-4">
            {technology.vendor && (
              <div>
                <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">Vendor</p>
                <p className="text-sm text-gray-900 dark:text-white">{technology.vendor}</p>
              </div>
            )}
            {(technology.categories?.length > 0 || technology.category) && (
              <div>
                <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">
                  {((technology.categories?.length || (technology.category ? 1 : 0)) > 1) ? 'Categories' : 'Category'}
                </p>
                <p className="text-sm text-gray-900 dark:text-white">
                  {technology.categories?.length ? technology.categories.join(', ') : technology.category}
                </p>
              </div>
            )}
          </div>

          {/* Asset Classes */}
          {assetLabels.length > 0 && (
            <div>
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Asset Classes</p>
              <div className="flex flex-wrap gap-1.5">
                {assetLabels.map(label => (
                  <span
                    key={label}
                    className="text-xs px-2 py-1 rounded-full bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                  >
                    {label}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Operational Functions */}
          {functionLabels.length > 0 && (
            <div>
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Operational Functions</p>
              <div className="flex flex-wrap gap-1.5">
                {functionLabels.map(label => (
                  <span
                    key={label}
                    className="text-xs px-2 py-1 rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-accent-200"
                  >
                    {label}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Tool/Vendor Description */}
          {technology.description && (
            <div>
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">Tool/Vendor Description</p>
              <p className="text-sm text-gray-700 dark:text-gray-300">{technology.description}</p>
            </div>
          )}

          {/* Client Usage Context */}
          {technology.usageContext && (
            <div>
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">Client Usage Context</p>
              <p className="text-sm text-gray-700 dark:text-gray-300">{technology.usageContext}</p>
            </div>
          )}

          {/* Ideal Client Profile */}
          {technology.idealClientProfile && (
            <div className="p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
              <p className="text-xs font-medium text-blue-700 dark:text-blue-300 mb-1">Ideal Client Profile / Target Market</p>
              <p className="text-xs text-blue-600 dark:text-blue-400">{technology.idealClientProfile}</p>
            </div>
          )}

          {/* Notes */}
          {technology.notes && (
            <div>
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">Notes</p>
              <p className="text-sm text-gray-700 dark:text-gray-300">{technology.notes}</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end p-6 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={onEdit}
            className="btn-primary text-sm flex items-center gap-1.5"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Edit
          </button>
        </div>
      </div>
    </div>
  )
}

export default TechnologyDetailModal
